import React from "react";

import FullScreenExit from "@mui/icons-material/FullscreenExit";
import { Box, IconButton, Modal, Stack, Typography } from "@mui/material";

const modalStyle = {
  position: "absolute" as "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  width: "100%",
  height: "100%",
  bgcolor: "white",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden"
};

interface FullscreenModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

export const FullscreenModal: React.FC<FullscreenModalProps> = ({ open, title, onClose, children }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        {/* Header */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            p: "16px",
            borderBottom: "1px solid #e5e9eb"
          }}
        >
          <Typography sx={{ fontSize: "18px", fontWeight: 500, color: "#071f35" }}>{title}</Typography>
          <IconButton onClick={onClose} sx={{ width: "24px", height: "24px", padding: "4px" }}>
            <FullScreenExit sx={{ fontSize: "16px", color: "#071f35" }} />
          </IconButton>
        </Stack>

        {/* Content */}
        <Box sx={{ p: "16px", overflow: "auto", flex: 1 }}>{children}</Box>
      </Box>
    </Modal>
  );
};
